var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_component-post-detail" },
    [_vm.isNew ? _c("Form") : _c("Pay", { attrs: { id: _vm.id } })],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }